import React from "react";
import Image from "next/image";
import classNames from "lib/classNames";

export default function ParagraphImage({ data, level }) {
  return level > 1 ? (
    <ParagraphImageContent data={data} />
  ) : (
    <div className="mx-auto lg:max-w-screen-lg h-full">
      <ParagraphImageContent data={data} />
    </div>
  );
}

function ParagraphImageContent({ data }) {
  const maintainRatio = data.field_maintain_ratio || false;

  return (
    <figure
      className={classNames(
        "relative aspect-w-16 aspect-h-10 h-full",
        !maintainRatio && "rounded-md overflow-hidden"
      )}
    >
      <Image
        src={
          maintainRatio
            ? data.field_image.image_style_uri.large_scale
            : data.field_image.image_style_uri.medium_16by10
        }
        alt={data.field_image.resourceIdObjMeta.alt}
        layout="fill"
        objectFit={maintainRatio ? "contain" : "cover"}
        objectPosition="center"
      />
      {data.field_image.resourceIdObjMeta.title && (
        <figcaption className="absolute left-1/2 right-auto top-auto -translate-x-1/2 h-auto w-auto px-4 py-1 bg-primary text-white rounded-t-md">
          {data.field_image.resourceIdObjMeta.title}
        </figcaption>
      )}
    </figure>
  );
}
